import type { Fetch } from '../../shared/types';
import { Zap } from '../../zapier/types';
import {
  Schedule,
  Filter,
  indexToDom,
  indexToDow,
  indexToHod,
} from '@zapier/transfer';
import { ZapierSession } from '@zapier/universal-layout';

type RequestData = {
  accountId: ZapierSession['currentAccountId'];
  zapId: Zap['id'];
};

type Response = {
  id: string;
  zap_id: Zap['id'];
  accountId: ZapierSession['currentAccountId'];
  filters: Filter.Criteria[];
  timezone: string;
  frequency: Schedule.Frequency;
  hour_of_day?: string;
  day_of_week?: string;
  day_of_month?: string;
};

type Result = {
  scheduleId: string;
  frequency: Schedule.Frequency;
  scheduleParams: Schedule.Params;
  filterParams: Filter.Criteria[];
};

export const getSchedule = async (
  fetch: Fetch,
  { accountId, zapId }: RequestData
): Promise<Result | undefined> =>
  fetch<Response>(`v1/scheduled-transfers/${zapId}/`, {
    headers: {
      'x-account-id': String(accountId),
    },
  }).then(
    ({ id, filters, frequency, hour_of_day, day_of_month, day_of_week }) => ({
      frequency,
      scheduleId: id,
      scheduleParams: {
        hod: indexToHod(hour_of_day),
        dow: indexToDow(day_of_week),
        dom: indexToDom(day_of_month) as any, // TODO: fix Schedule.Params type in @zapier/transfer
      },
      filterParams: filters,
    }),
    () => undefined
  );

export default getSchedule;
